<mat-toolbar class="navbar" [ngClass]="{ 'not-top': state === 'not-top' }">
	<div class="navbar-container">
		<div
			class="navbar-logo"
			[routerLink]="isLoggedIn ? '/claims/dashboard' : '/claims'"
		>
			<img
				src="https://storage.googleapis.com/dev-ps-asset/rider-protection/partner-logo/shopeefood-logo.png"
				alt="policy-street-claims-logo"
			/>
		</div>
		<span fxFlex></span>
		<div class="desktop-actions">
			<button
				*ngIf="isLoggedIn"
				mat-flat-button
				routerLink="/claims/dashboard"
				routerLinkActive="desktop-actions__active"
			>
				<div class="desktop-actions__row">
					<img
						width="24"
						height="24"
						class="icon-active"
						src="/assets/icons/dashboard-white.svg"
						alt="dashboard-icon"
					/>
					<img
						width="24"
						height="24"
						class="icon-inactive"
						src="/assets/icons/dashboard-black.svg"
						alt="dashboard-icon"
					/>
					<span style="font-weight: 600">{{
						"navigation.dashboard" | translate
					}}</span>
				</div>
			</button>

			<button
				*ngIf="isLoggedIn"
				mat-flat-button
				routerLink="/policies"
				routerLinkActive="desktop-actions__active"
			>
				<div class="desktop-actions__row">
					<img
						width="24"
						height="24"
						class="icon-active"
						src="/assets/icons/health_and_safety-white.svg"
						alt="policies-icon"
					/>
					<img
						width="24"
						height="24"
						class="icon-inactive"
						src="/assets/icons/health_and_safety-black.svg"
						alt="policies-icon"
					/>
					<span style="font-weight: 600">{{
						"navigation.policies" | translate
					}}</span>
				</div>
			</button>

			<button mat-flat-button [matMenuTriggerFor]="claims">
				<div class="desktop-actions__row">
					<img
						width="24"
						height="24"
						class="icon-inactive"
						src="/assets/icons/currency_exchange.svg"
						alt="claims-icon"
					/>
					<span style="font-weight: 600">{{
						"navigation.claims" | translate
					}}</span>
					<mat-icon>expand_more</mat-icon>
				</div>
			</button>

			<button mat-flat-button [matMenuTriggerFor]="language">
				<span style="font-weight: 600">{{
					"language." + translate.currentLang | translate
				}}</span>
				<mat-icon>expand_more</mat-icon>
			</button>

			<button mat-icon-button class="navbar-menu" [matMenuTriggerFor]="profile">
				<mat-icon class="profile-icon">account_circle</mat-icon>
			</button>
		</div>

		<div class="mobile-actions">
			<button mat-flat-button (click)="openMenu()">
				<mat-icon>menu</mat-icon>
			</button>
		</div>
	</div>
</mat-toolbar>

<mat-menu #claims="matMenu">
	<button
		*ngIf="isLoggedIn"
		mat-menu-item
		(click)="handleNavigate('/claim-status')"
	>
		<div class="menu-row">
			<img
				width="24"
				height="24"
				class="icon-inactive"
				src="/assets/icons/person_shield.svg"
				alt="my-claims-icon"
			/>
			<span style="font-weight: 600">{{ "My Claims" | translate }}</span>
		</div>
	</button>
	<button mat-menu-item (click)="handleNavigate('/claims-submit')">
		<div class="menu-row">
			<img
				width="24"
				height="24"
				class="icon-inactive"
				src="/assets/icons/assignment_add.svg"
				alt="submit-new-claim-icon"
			/>
			<span style="font-weight: 600">{{ "Submit New Claim" | translate }}</span>
		</div>
	</button>
	<button *ngIf="!isLoggedIn" mat-menu-item (click)="handleNavigate('/claims')">
		<div class="menu-row">
			<mat-icon style="margin: 0; color: black">home</mat-icon>
			<span style="font-weight: 600">{{
				"navigation.overview" | translate
			}}</span>
		</div>
	</button>
</mat-menu>

<mat-menu #language="matMenu">
	<button mat-menu-item (click)="switch('en')">
		<span>{{ "language.en" | translate }}</span>
	</button>
	<button mat-menu-item (click)="switch('bm')">
		<span>{{ "language.bm" | translate }}</span>
	</button>
</mat-menu>

<mat-menu #profile="matMenu">
	<button
		mat-menu-item
		(click)="handleNavigate('/account/profile')"
		*ngIf="isLoggedIn"
	>
		<mat-icon>person</mat-icon
		><span>{{ "navigation.profile" | translate }}</span>
	</button>

	<button mat-menu-item (click)="handleLogout()" *ngIf="isLoggedIn">
		<mat-icon>logout</mat-icon><span>{{ "common.logout" | translate }}</span>
	</button>

	<button mat-menu-item (click)="handleNavigate('/login')" *ngIf="!isLoggedIn">
		<mat-icon>login</mat-icon><span>{{ "common.login" | translate }}</span>
	</button>
</mat-menu>
